import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import stitches from "../theme.config.es.js";
import LinkButton from "./LinkButton.es.js";
import { clsx } from "../../utils/mergeProps.es.js";
const listBase = stitches.css({
  display: "flex",
  margin: 0,
  padding: 0,
  listStyle: "none",
  "&& > * + *": {
    marginLeft: "$tabs-ml"
  }
});
const tabBase = stitches.css({
  display: "flex",
  margin: 0,
  "&& > *, && a": {
    color: "$tabs-inactive-color"
  },
  "&& a, && > button": {
    display: "flex",
    padding: "$tabs-py $tabs-px",
    textDecoration: "none",
    "&:focus": {
      outline: "$outlines$focusOutline",
      outlineOffset: "$outlines$focusOutlineOffset"
    }
  }
});
const activeTab = stitches.css({
  boxShadow: "$tabs-active-box-shadow",
  "&& > *, && a": {
    color: "$tabs-active-color",
    ":focus": {
      outline: "$outlines$focusOutline",
      outlineOffset: "$outlines$focusOutlineOffset"
    }
  },
  "&& a, && > button": {
    "&:hover": {
      boxShadow: "$tabs-hover-box-shadow"
    }
  }
});
const Tab = forwardRef(function Tab2(props, ref) {
  const { active, ...rest } = props;
  const tabProps = { ...rest, ref, role: "tab" };
  return /* @__PURE__ */ jsx("li", { className: clsx(tabBase(), active && activeTab()), role: "presentation", children: /* @__PURE__ */ jsx(LinkButton, { ...tabProps }) });
});
const TabList = ({ onKeyDown, children }) => /* @__PURE__ */ jsx("ul", { className: listBase(), role: "tablist", onKeyDown, children });
export {
  Tab,
  TabList
};
//# sourceMappingURL=Tabs.es.js.map
